import type { SVGProps } from 'react';

const SoundOff = (props: SVGProps<SVGSVGElement>) => (
    <svg width="23" height="16" fill="none" viewBox="0 0 23 16" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M10 1 5 5H1v6h4l5 4V1ZM22 5l-6 6M16 5l6 6"
            stroke="#fff"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SoundOff;
